import * as React from 'react';

import type {Lead as LeadFragment} from 'nutshell-graphql-types';

import {StagesCarousel} from './stages-carousel';
import {StagesCarouselEmpty} from './stages-carousel-empty';

type Props = {
    lead: LeadFragment;
    canAccessSetup: boolean;
    onRefetchLead: () => any;
    temporarilySelectedStageId: string | null | undefined;
    onTemporarilySelectStage: (id: string) => any;
    onClearTemporaryStageSelection: () => any;
    isWidget: boolean;
};

export class StagesCarouselContainer extends React.PureComponent<Props> {
    render() {
        return (
            <div>
                {this.props.lead.stageset && this.props.lead.stages.totalCount > 0 ? (
                    <StagesCarousel
                        lead={this.props.lead}
                        onTemporarilySelectStage={this.props.onTemporarilySelectStage}
                        onClearTemporaryStageSelection={this.props.onClearTemporaryStageSelection}
                        temporarilySelectedStageId={this.props.temporarilySelectedStageId}
                        onRefetchLead={this.props.onRefetchLead}
                        isWidget={this.props.isWidget}
                    />
                ) : (
                    <StagesCarouselEmpty
                        leadId={this.props.lead.id}
                        canAccessSetup={this.props.canAccessSetup}
                    />
                )}
            </div>
        );
    }
}
